<template>
  <div id="page-user-edit">
    <vx-card v-if="operation_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <div id="user-edit-tab-info">
            <!-- Content Row -->
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-full">
                <vx-input-group class="mt-8">
                  <template slot="prepend">
                    <div class="prepend-text bg-primary">
                      <span>Transport ID #</span>
                    </div>
                  </template>
                  <vs-input v-model="operation_data.id" disabled size="default" />
                </vx-input-group>
                <div class="w-full mt-2" style="
                    background-color: #ffff99;
                    border: 1px solid #ffff99;
                    border-radius: 5px;
                  ">
                  <div style="font-size: 85%">Transporter</div>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <v-select style="background-color: #ffffff" autocomplete :options="data_option_people_name"
                        v-model="personId" @input="getBillingAndDeliveryAddressList(true)" />
                    </div>
                  </div>
                </div>
                <div class="w-full mt-4" style="font-size: 85%">
                  <div>Transporter Billing Address</div>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <v-select :options="data_option_billing_address" v-model="billingAddressId" / :disabled="addressesLoading">
                      <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                           choisir une adresse quelconque du client a sa place. -->
                      <span v-if="billingAddressUnlinked" class="text-warning text-sm">No billing address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                    </div>
                  </div>
                </div>
                <p class="w-full mt-4" style="font-size: 85%">
                  &nbsp;Transport Date
                  <datepicker :inline="false" v-model="operation_data.date"></datepicker>
                </p>

                <div class="vx-row">
                  <div class="vx-col w-1/2" style="font-size: 85%">
                    <div class="w-full mt-4">Delivery date</div>
                    <datepicker :inline="false" v-model="dataTransitDate" @input="updateTransitPeriod"></datepicker>
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-input name="number" label="Transit Period (in days)" v-validate="'numeric'"
                      v-model="operation_data.transit_period" class="w-full mt-3" @input="updateDeliveryDate" />
                    <span class="text-danger text-sm" v-show="errors.has('number')">{{ errors.first("number") }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/3 w-full">
                <div class="w-full">
                  <vx-input-group class="mt-8">
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>Invoice No</span>
                      </div>
                    </template>
                    <vs-input v-model="operation_data.transport_invoice_no" size="default" />
                  </vx-input-group>
                  <div class="vx-row">
                    <div class="vx-col w-1/2" style="font-size: 85%">
                      <vs-input name="cost" label="Transport cost (EUR)" v-validate="'numeric'" v-model="transportCost"
                        class="mt-2 w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        " />
                      <span class="text-danger text-sm" v-show="errors.has('cost')">{{ errors.first("cost") }}</span>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full mt-3">
                      <div class="w-full"
                        style="background-color: #ffff99;border: 1px solid #ffff99;border-radius: 5px;">
                        <div style="font-size: 85%">Payment Method</div>
                        <v-select class="w-full" style="background-color: #ffffff" autocomplete
                          :options="payment_method" v-model="paymentmtd" />
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <!--<div class="vx-col md:w-1/2 w-full" style="font-size: 85%">
                      <vs-input class="w-full mt-3" label="Date of receipt of documents" v-model="operation_data.transport_invoice_date"
                        type="date" name="birthday" />
                    </div>-->
                    <div class="vx-col md:w-1/2 w-full" style="font-size: 85%"
                      v-if="paymentmtd && paymentmtd.value != 'direct'">
                      <vs-input class="w-full mt-3" label="Payment Date (estimate)"
                        v-model="operation_data.transport_invoice_due_date" type="date" name="birthday" />
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-1/2 mt-3">
                      <div style="font-size: 85%">Payment Status</div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <v-select :options="data_option_payment_status" v-model="statusId" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/3 w-full">
                <div class="w-full">
                  <div class="vx-row">
                    <div class="vx-col w-1/2 mt-3">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <div style="font-size: 85%">Transport Type</div>
                        <v-select class="w-full" style="background-color: #ffffff" autocomplete
                          :options="select_transport_type" v-model="transporttip" />
                      </div>
                    </div>
                    <div class="vx-col w-1/2 mt-3">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <div style="font-size: 85%">Trailer Type</div>
                        <v-select style="background-color: #ffffff" class="w-full" autocomplete
                          :options="select_trailer_type" v-model="remorcatip" />
                      </div>
                    </div>
                  </div>
                  <!--<div class="vx-row">
                    <div class="vx-col w-1/2 mt-4" style="font-size: 85%">
                      <div
                        class="w-full"
                        style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        "
                      >
                        Sumal Transport?
                        <vs-switch
                          class="w-full"
                          color="primary"
                          icon-pack="feather"
                          vs-icon-on="icon-yes"
                          vs-icon-off="icon-no"
                          v-model="operation_data.transport_sumal"
                        >
                          <span slot="on">YES</span>
                          <span slot="off">NO</span>
                        </vs-switch>
                      </div>
                    </div>
                  </div>-->
                  <div class="vx-row">
                    <div class="vx-col w-1/2 mt-2" style="font-size: 85%">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <vs-input label="Weight (t)" v-model="operation_data.transport_tonaj" v-validate="'integer'"
                          class="w-full" name="weight" />
                        <span class="text-danger text-sm" v-show="errors.has('weight')">{{
                          errors.first("weight")
                        }}</span>
                      </div>
                    </div>
                    <div class="vx-col w-1/2 mt-2" style="font-size: 85%">
                      <div class="w-full" style="
                          background-color: #ffff99;
                          border: 1px solid #ffff99;
                          border-radius: 5px;
                        ">
                        <vs-input label="Floor length (ml)" v-model="operation_data.transport_podea_ml"
                          v-validate="'integer'" name="floor" class="w-full" />
                        <span class="text-danger text-sm" v-show="errors.has('floor')">{{
                          errors.first("floor")
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-1/2" style="font-size: 85%">
                      <vs-input label="Truck Driver (name)" v-model="operation_data.driver" class="mt-2 w-full" />
                    </div>
                    <div class="vx-col w-1/2" style="font-size: 85%">
                      <vs-input label="Truck Driver (phone)" v-model="operation_data.driver_phone"
                        class="mt-2 w-full" />
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-1/2">
                      <vs-input label="Truck Plate" v-model="operation_data.truck_plate" class="mt-3 w-full" />
                    </div>
                    <div class="vx-col w-1/2">
                      <vs-input label="Trailer Plate" v-model="operation_data.trailer_plate" class="mt-3 w-full" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div id="data-list-list-view" class="data-list-container">
              <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar"
                :data="sidebarData" />

              <vs-table ref="table" :data="invoiceattached">
                <div slot="header" class="
                    flex flex-wrap-reverse
                    items-center
                    flex-grow
                    justify-between
                  ">
                  <div class="
                      flex flex-wrap-reverse
                      items-center
                      data-list-btn-container
                    ">
                    <div class="
                        btn-add-new
                        p-3
                        mt-8
                        mb-4
                        mr-4
                        rounded-lg
                        cursor-pointer
                        flex
                        items-center
                        justify-center
                        text-lg
                        font-medium
                        text-base text-primary
                        border border-solid border-primary
                      " @click="addNewData">
                      <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                      <span class="ml-2 text-base text-primary">Link Reception/Purchase Order</span>
                    </div>
                  </div>
                </div>

                <template slot="thead">
                  <vs-th>#</vs-th>
                  <vs-th>Reception/PO</vs-th>
                  <vs-th>Supplier</vs-th>
                  <vs-th>Source</vs-th>
                  <!--<vs-th>Aviz Number</vs-th>-->
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="font-medium truncate">
                          {{ indextr + 1 }}
                        </p>
                      </vs-td>

                      <vs-td>
                        <p class="font-medium truncate">REF #{{ tr.id }}</p>
                      </vs-td>

                      <vs-td>
                        <p>{{ tr.people }}</p>
                      </vs-td>

                      <vs-td>
                        <p>{{ tr.place_name }}, {{ tr.country }}</p>
                      </vs-td>

                      <!--<vs-td>
                        <p>
                          Seria {{ tr.aviz_serie }}&nbsp;&nbsp; Nr.
                          {{ tr.aviz_number }}
                        </p>
                      </vs-td>-->
                      <vs-td class="whitespace-no-wrap">
                        <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="editData(tr)" />
                        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          class="ml-2" @click.stop="unlinkInvoice(tr.id, tr.people)" />
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>

            <!-- Save & Reset Button -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button v-if="operation_data.isactive" type="border" color="danger" icon-pack="feather"
                    icon="icon-trash" @click="confirmDeleteRecord">Disable</vs-button>
                  <vs-button v-else type="border" color="success" icon-pack="feather" icon="icon-trash"
                    @click="confirmEnableRecord">Enable</vs-button>
                  <vs-button class="ml-auto" color="success" @click="save_changes" :disabled="!validateForm || addressesLoading">Save
                    Changes</vs-button>
                </div>
                <br />
              </div>
            </div>
            <div class="vx-row" style="padding: 20px">
              <GmapMap :center="center" :zoom="4" map-type-id="terrain" style="width: 100%; height: 500px">
                <GmapMarker :key="index" v-for="(m, index) in markers" :position="m" :clickable="false"
                  :draggable="false" @click="center = m" />
              </GmapMap>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebarAviz.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import { takePersonOption } from "@/helpers/personOption";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import addressSelection from "@/mixins/addressSelection";
import moment from "moment";
import eurRonRate from "@/mixins/eurRonRate";

export default {
  mixins: [eurRonRate, addressSelection],
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker,
  },
  data() {
    return {
      statusId: null,
      paymentmtd: null,
      data_option_payment_status: [],
      dataTransitDate: null,
      operation_data: null,
      invoiceattached: null,
      data_option_people_name: [],
      //operation_data: JSON.parse(JSON.stringify(this.data)),
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      personId: null,
      invoicetounlink: null,
      data_option_operation: [],
      linkedOperationId: [],
      data_option_billing_address: [],
      data_option_delivery_address: [],
      remorcatip: null,
      transporttip: null,
      billingAddressId: null,
      deliveryAddressId: null,
      transportCost: null,
      paymentDeadline: null,
      center: { lat: 50.0, lng: 12.0 },
      markers: [],
      select_transport_type: [
        { label: "Rutier", value: "Rutier" },
        { label: "Intermodal", value: "Intermodal" },
      ],
      select_trailer_type: [
        { label: "tautliner", value: "tautliner" },
        { label: "MEGA", value: "MEGA" },
      ],
      payment_method: [
        { label: "30 days from receipt of documents", value: "30 days" },
        { label: "Payment upon receipt of documents", value: "direct" },
      ],
    };
  },
  computed: {
    products() {
      return this.$store.state.operationList.operationproducts;
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.operation_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.operation_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
  },
  methods: {
    async getPaymentStatus() {
      axios.get("/salestatus/data").then((response) => {
        this.data_option_payment_status = [...response.data];
        if (this.operation_data.salestatus) {
          const ItemIndex = this.data_option_payment_status.findIndex(
            (p) => p.value === this.operation_data.salestatus.id
          );
          this.statusId = this.data_option_payment_status.splice(ItemIndex, 1);
        } else {
          this.statusId = this.data_option_payment_status.splice(2, 1);
        }
      });
    },
    updateTransitPeriod() {
      var start = moment(this.operation_data.date);
      var end = moment(this.dataTransitDate);
      this.operation_data.transit_period = Math.floor((end - start) / 86400000);
    },
    updateDeliveryDate() {
      var start = moment(this.operation_data.date).add(
        this.operation_data.transit_period,
        "days"
      );
      this.dataTransitDate = moment(start).toString("YYYY-MM-DD");
    },
    async recalculateMap() {
      axios
        .get("/getpersonaddressmap/" + this.$route.params.userId)
        .then((response) => {
          this.markers = response.data;
          this.center = response.data[0];
        });
    },
    // Les deux listes d'options d'abord (Promise.all), la selection ENSUITE.
    // Avant, la resolution de la selection etait lancee depuis chacun des deux
    // .then() : quatre requetes concurrentes, et la premiere tournait contre une
    // liste d'options encore vide. Deux vagues, un seul ordre possible.
    //
    // `personChanged` = le contact vient d'etre change dans le v-select. On ne
    // relit alors PAS l'adresse liee a l'operation : elle appartient encore a
    // l'ANCIEN contact, et la reinjecter dans les options du nouveau est
    // exactement le « l'adresse a saute » signale. On propose l'adresse par
    // defaut du nouveau contact, visible dans le v-select avant tout Save.
    async getBillingAndDeliveryAddressList(personChanged = false) {
      this.billingAddressId = null;
      this.deliveryAddressId = null;
      this.billingAddressUnlinked = false;
      this.deliveryAddressUnlinked = false;
      this._beginAddressLoading();
      // Sans contact, il n'y a pas d'adresse a charger : ne pas dereferencer
      // this.personId.value (TypeError silencieux qui laissait le drapeau de
      // chargement a vrai, donc le bouton Save grise pour toujours).
      if (!this.personId || this.personId.value === null || this.personId.value === undefined) {
        this.data_option_billing_address = [];
        this.data_option_delivery_address = [];
        this._endAddressLoading();
        return;
      }
      try {
        const [billing, delivery] = await Promise.all([
          axios.get("/person/getaddressbilling/" + this.personId.value).catch(() => ({ data: [] })),
          axios.get("/person/getaddressdelivery/" + this.personId.value).catch(() => ({ data: [] })),
        ]);
        this.data_option_billing_address = [...((billing && billing.data) || [])];
        this.data_option_delivery_address = [...((delivery && delivery.data) || [])];
        await this.getSelectedBillingAndDeliveryAddressList(personChanged);
      } finally {
        this._endAddressLoading();
      }
    },
    // `personChanged` : voir getBillingAndDeliveryAddressList. Les deux
    // chaines sont RENVOYEES, donc reellement attendues par l'appelant —
    // avant, elles partaient en fire-and-forget et le drapeau de chargement
    // retombait a faux alors que les adresses n'etaient pas encore resolues.
    async getSelectedBillingAndDeliveryAddressList(personChanged = false) {
      const billingChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressbilling/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.billingAddressId = this.pickAddressOption(this.data_option_billing_address, selectedAddress);
            this.billingAddressUnlinked = false;
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.billingAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.billingAddressId)
              this.billingAddressId = this.proposeAddressOption(this.data_option_billing_address);
          });

      const deliveryChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressdelivery/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.deliveryAddressId = this.pickAddressOption(this.data_option_delivery_address, selectedAddress);
            this.deliveryAddressUnlinked = false;
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.deliveryAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.deliveryAddressId)
              this.deliveryAddressId = this.proposeAddressOption(this.data_option_delivery_address);
          });

      return Promise.all([billingChain, deliveryChain]);
    },
    calculateTotal() {
      this.dataTotalPrice = this.dataUnitPrice * this.dataQuantity;
    },
    async getPeople() {
      axios.get("/people_name/data").then((response) => {
        this.data_option_people_name = [...response.data];
        // Le contact du document, même inactif — jamais le dernier de la liste (helpers/personOption).
        this.personId = takePersonOption(this.data_option_people_name, this.operation_data.people[0]);
        this.getBillingAndDeliveryAddressList();
      });
    },
    confirmDeleteRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable",
      });
    },
    confirmEnableRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable",
      });
    },
    enableRecord() {
      this.invoiceattached.forEach(e => {
        axios
          .post("/operation/enable", { id: e.id })
          .catch((err) => {
          this.showActionFailed(err);
        });
      });
      axios
        .post("/operation/enable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/transport/" + this.operation_data.id });
      this.showEnableSuccess();

      /*
            axios
              .post("/operation/enable", { id: this.operation_data.id })
              .catch((err) => {
          this.showActionFailed(err);
        });
            this.$router.push({ path: "/transport/" + this.operation_data.id });
            this.showEnableSuccess();*/
    },
    // Les .catch vides masquaient tout echec de /operation/enable|disable :
    // l'ecran affichait « successfully deleted » et l'operation etait toujours la.
    showActionFailed(err) {
      console.error("operation enable/disable:", err);
      const data = err && err.response && err.response.data;
      this.$vs.notify({
        color: "danger",
        title: "Action NOT applied",
        text: (data && (data.message || data.error)) || (err && err.message) ||
          "The server refused the operation. Reload the page to see its real state.",
        time: 12000,
      });
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Enable",
        text: "The selected operation was successfully enabled",
      });
    },
    deleteRecord() {
      this.invoiceattached.forEach(e => {
        axios
          .post("/operation/disable", { id: e.id })
          .catch((err) => {
          this.showActionFailed(err);
        });
      });
      axios
        .post("/operation/disable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/transport/" + this.operation_data.id });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Deleted",
        text: "The selected operation was successfully deleted",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    addNewData() {
      if (this.operation_data.id) {
        var idtransport = this.operation_data.id;
        var datetransport = this.operation_data.date;
        this.sidebarData = { idtransport, datetransport };
        this.toggleDataSidebar(true);
      } else {
        this.$vs.notify({
          color: "alert",
          title: "Alert!",
          text: "Please select a Person before!",
        });
      }
    },
    save_changes() {
      // Un enregistrement lance pendant le chargement des adresses partait avec
      // une adresse nulle — ou pire, celle de l'ANCIEN contact.
      const addressBlocked = this.addressSaveBlockReason();
      if (addressBlocked) {
        this.$vs.notify({ color: "warning", title: "Please wait", text: addressBlocked });
        return;
      }
      if (this.operation_data.transit_period != null) {
        var personIdentifiant = null;
        if (this.personId) {
          personIdentifiant = this.personId.value;
        } else {
          personIdentifiant = null;
        }
        const objprod = {
          idoperation: this.operation_data.id,
          description: "Transport",
          idproduct: 1,
          quantity: 1,
          price: -Math.abs(this.transportCost),
          price_ron: -Math.abs(
            this.transportCost * localStorage.getItem("rate_eur_ron")
          ),
        };
        this.$store
          .dispatch("operationList/updateTransportCost", objprod)
          .then((res) => {
            let transit = null;
            if (this.operation_data.transit_period) {
              transit = this.operation_data.transit_period;
            } else transit = 0;
            let _idbilling = null;
            if (this.billingAddressId) {
              _idbilling = this.billingAddressId.value;
            }

            let transporttiplt = null
            if (this.transporttip) transporttiplt = this.transporttip.value
            let remorcatiplt = null
            if (this.remorcatip) remorcatiplt = this.remorcatip.value

            let str_transport_method = null
            if (this.paymentmtd) str_transport_method = this.paymentmtd.value
            if (str_transport_method == 'direct') this.operation_data.transport_invoice_due_date = null
            else if (str_transport_method == '30 days');
            else this.operation_data.transport_invoice_due_date = null

            const obj = {
              id: this.operation_data.id,
              idperson: personIdentifiant,
              date: moment(this.operation_data.date),
              driver: this.operation_data.driver,
              idsalestatus: this.statusId.value,
              driver_phone: this.operation_data.driver_phone,
              truck_plate: this.operation_data.truck_plate,
              trailer_plate: this.operation_data.trailer_plate,
              transit_period: transit,
              idbilling: _idbilling,
              transport_invoice_date: moment(
                this.operation_data.transport_invoice_date
              ),
              transport_invoice_due_date: moment(
                this.operation_data.transport_invoice_due_date
              ),
              transport_invoice_no: this.operation_data.transport_invoice_no,
              transport_podea_ml: this.operation_data.transport_podea_ml,
              transport_tonaj: this.operation_data.transport_tonaj,
              transport_sumal: this.operation_data.transport_sumal,
              transport_tip: transporttiplt,
              transport_remorca_type: remorcatiplt,
              transport_payment_method: str_transport_method
            };
            console.log(obj);

            if (this.operation_data.id) {
              this.$store
                .dispatch("operationList/updateOperation", obj)
                .catch((err) => {
                  console.error(err);
                });
              this.$router.push({ name: "incoming-transport/transport-view" });

              this.$vs.notify({
                color: "success",
                title: "Operation Updated!",
                text: "The transport was successfully updated",
              });
            }
          });
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Transit Period Required!",
          text: "Please input a transit period",
        });
      }
    },
    showUnlinkSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Reception/PO Unlinked",
        text: "The Reception/PO was successfully unlinked",
      });
    },
    unlinkInvoiceOne() {
      const obj = {
        idtransport: this.operation_data.id,
        idinvoice: this.idinvoicetounlink,
        /*aviz_serie: this.dataAvizSerie,
        aviz_number: this.dataAvizNumber,*/
        delete: true,
      };
      this.$store
        .dispatch("operationList/UnlinkOperationToTransport", obj)
        .then((response) => {
          this.$vs.notify({
            color: "success",
            title: "Reception/PO unlinked",
            text: "The selected Reception/PO was successfully unlinked",
          });
        })
        .catch((err) => {
          console.error(err);
        });
      this.showUnlinkSuccess();
    },
    unlinkInvoice(id, name) {
      this.idinvoicetounlink = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Unlink",
        text: `You are about to unlink the Reception/PO of ${name}`,
        accept: this.unlinkInvoiceOne,
        acceptText: "Unlink Reception/PO",
      });
    },
    editData(data) {
      data.idtransport = this.operation_data.id;
      data.datetransport = this.operation_data.date;
      data.aviz_number = data.aviz_number;
      data.aviz_serie = data.aviz_serie;
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetch_operation_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchOperation", userId)
          .then((res) => {
            this.operation_data = res.data;
            this.updateDeliveryDate();
            this.getPeople();

            this.getPaymentStatus();
            this.transportCost = Math.abs(
              res.data.products[0].operations_products.unit_price
            );

            const ItemIndex = this.select_trailer_type.findIndex(
              (p) => p.value === res.data.transport_remorca_type
            );
            this.remorcatip = this.select_trailer_type[ItemIndex];

            const ItemIndexTruck = this.select_transport_type.findIndex(
              (p) => p.value === res.data.transport_tip
            );
            this.transporttip = this.select_transport_type[ItemIndexTruck];


            const ItemIndexPaymentMtd = this.payment_method.findIndex(
              (p) => p.value === res.data.transport_payment_method
            );
            this.paymentmtd = this.payment_method[ItemIndexPaymentMtd];

            this.$store
              .dispatch(
                "operationList/fetcheurdifference",
                this.$route.params.userId
              )
              .catch((err) => {
                if (err.response.status === 404) {
                  this.user_not_found = true;
                  return;
                }
                console.error(err);
              });
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            } 
            console.error(err);
          });
      } else {
        this.operation_data = {};
      }
    },
    fetch_invoice_linked_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchInvoiceLinked", userId)
          .then((res) => {
            this.invoiceattached = res.data;
            this.markers = res.data;
          });
      } else {
        this.invoiceattached = {};
      }
    },
  },

  created() {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    this.fetch_operation_data(this.$route.params.userId);
    this.fetch_invoice_linked_data(this.$route.params.userId);
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

